<template>
  <el-dialog
    :title="$t('businessDatabusManage.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose"
  >
    <div style="text-align: center;">
      <p>{{ $t('businessDatabusManage.confirmDelete') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('businessDatabusManage.cancel') }}
      </el-button>
      <el-button type="primary" @click="deleteBusinessDatabus">
        {{ $t('businessDatabusManage.confirm') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteBusinessDatabus } from '@/api/dev/businessDatabusApi'

export default {
  name: 'DeleteBusinessDatabus',
  data() {
    return {
      dialogVisible: false,
      deleteInfo: {
        databusId: ''
      }
    }
  },
  methods: {
    open(row) {
      this.deleteInfo.databusId = row.databusId
      this.dialogVisible = true
    },
    handleClose() {
      this.deleteInfo = { databusId: '' }
    },
    async deleteBusinessDatabus() {
      try {
        await deleteBusinessDatabus(this.deleteInfo)
        this.$emit('refresh')
        this.dialogVisible = false
        this.$message.success(this.$t('businessDatabusManage.deleteSuccess'))
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>